export default __webpack_public_path__ + "static/media/hero8.e69fef5b.png";